export const external = [
	"ngCookies",
	"ngSanitize",
	"ngMaterial",
	"ngMessages",
	"ui.router",
	"ui.router.title",
	"ui.router.stateHelper",
	"uiSwitch",
	"ngNotify",
	"ui.select",
	"vcRecaptcha",
	"gettext",
    "ngResource",
    "md.data.table",
	"mgo-angular-wizard",
	"ngMaterialDatePicker",
	"color.picker",
	"dndLists"];



// WEBPACK FOOTER //
// ./sources/external.js